import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IAdminEventAwardsStore, IAward } from '../eventAwards/store';
import { IAdminEventFormatAwardsStore } from './store';

export interface IAdminEventFormatAwardsActions {
  get: (
    clubId: number,
    eventId: number,
    formatId: number,
    force?: boolean
  ) => { adminEventFormatAwards?: IAdminEventFormatAwardsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  create: async (
    state: IStore,
    clubId: number,
    eventId: number,
    formatId: number,
    instances: IAward
  ) => {
    const response = await request.patch(api.admin.eventFormatAwards(clubId, eventId, formatId), {
      instances
    });

    if (response.error) {
      return {
        errors: {
          adminEventFormatAwards: { msg: 'Error retrieving the Event Format Awards List.' }
        }
      };
    }

    return {
      adminEventFormatAwards: {
        ...state.adminEventFormatAwards,
        [eventId]: {
          ...state.adminEventFormatAwards[eventId],
          [formatId]: {
            ...response.reduce(
              (acc: IAdminEventAwardsStore, award: IAward) => ({
                ...acc,
                [award.user]: award
              }),
              {}
            )
          }
        }
      }
    };
  },
  get: async (
    state: IStore,
    clubId: number,
    eventId: number,
    formatId: number,
    force?: boolean
  ) => {
    if (
      state.adminEventFormatAwards[eventId] &&
      state.adminEventFormatAwards[eventId][formatId] &&
      !force
    ) {
      return {
        adminEventFormatAwards: state.adminEventFormatAwards
      };
    }

    const response = await request.get(api.admin.eventFormatAwards(clubId, eventId, formatId));

    if (response.error) {
      return {
        errors: {
          adminEventFormatAwards: { msg: 'Error retrieving the Event Format Awards List.' }
        }
      };
    }

    return {
      adminEventFormatAwards: {
        ...state.adminEventFormatAwards,
        [eventId]: {
          ...state.adminEventFormatAwards[eventId],
          [formatId]: {
            ...response.reduce(
              (acc: IAdminEventAwardsStore, award: IAward) => ({
                ...acc,
                [award.user]: award
              }),
              {}
            )
          }
        }
      }
    };
  }
};

export default actions;
